const religious = [
  {
    id: "christmas",
    date: "12-25",
    category: "religious",
    title: "Christmas",
    description: `Christmas celebrates the birth of Jesus Christ 
    and is observed with joy, generosity, and togetherness. 
    Families gather, exchange gifts, and reflect on love and kindness.`,
    color: "#1E88E5"
  }
];

export default religious;